import { render, staticRenderFns } from "./vrhyhddetail.vue?vue&type=template&id=6d019ec7&scoped=true&"
import script from "./vrhyhddetail.vue?vue&type=script&lang=js&"
export * from "./vrhyhddetail.vue?vue&type=script&lang=js&"
import style0 from "./vrhyhddetail.vue?vue&type=style&index=0&id=6d019ec7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d019ec7",
  null
  
)

export default component.exports